<!--
 * @Author: Gaho
 * @Date: 2024-03-05 14:24:04
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-22 13:05:49
 * @Description: 
-->
<template>
    <div class="ring-jackpot">
        <button class="question">
            <IconSvgUse use="icon-question" width="15" height="15" @click="handleOpenJacketPot" />
        </button>
        <img src="@/assets/imgs/casino/circle/jackpot.webp" alt="" class="jackpot-img">
        <div class="jackpot-sum">
            {{ handleExchangeRate(jackpotSize)?.toFixed(0) }}
            {{ currentCurrency.toLocaleUpperCase() }}
        </div>
        <div class="jackpot-progress">
            <div style="width: 55.732%;"></div>
        </div>
        <span class="jackpot-text">
            {{ $t('otherJackpots') }}: <span class="jackpot-count">44268</span>
        </span>
        <ModalJackpot
            :visible="jackpotModal"
            game="Circle"
            :update="handleOpenJacketPot"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useSettingsStore from '@/stores/settings';
export default defineComponent({
    name: 'circleJackpot',
    props: {
        jackpotSize: {
            type: Number,
            default: 0
        }
    },
    data(){
        return {
            jackpotModal: false
        }
    },
    computed: {
        currentCurrency(){
            return useSettingsStore().pickedCurrency || 'btc';
        }
    },
    methods: {
        handleOpenJacketPot(){
            this.jackpotModal = !this.jackpotModal;
        }
    }
})
</script>

<style lang="scss" scoped>
.ring-jackpot {
    left: 20px;
    position: absolute;
    top: 20px;
    z-index: 4;
    @media (max-width: 1100px) {
        left: 50%;
        top: 55px;
        transform: translate(-50%);
    }
    @media (max-width: 550px) {
        top: 45px;
        transform: translate(-50%) scale(.8);
    }
    @media (max-width: 450px) {
        top: 35px;
        transform: translate(-50%) scale(.7);
    }
    button {
        background-color: transparent;
        border: 0;
        display: block;
        height: 16px;
        padding: 0;
        position: absolute;
        right: -20px;
        top: -3px;
        width: 16px;
        svg {
            display: block;
            height: 16px;
            transition: all .3s;
            width: 16px;
            fill: #5b6773;
            color: #5b6773;
            
        }
        &:hover {
            svg {
                color: #fff;
                fill: #fff;
            }
        }
    }
    .jackpot-img {
        width: 146px;
        margin-bottom: 8px;
    }
    .jackpot-sum {
        color: #ffc51c;
        font-size: 16px;
        font-weight: 600;
        line-height: 21px;
        @media (max-width: 1100px) {
            text-align: center;
        }
    }
    .jackpot-progress {
        background: #404751;
        border-radius: 3px;
        height: 5px;
        margin: 10px 0 4px;
        width: 104px;
        @media (max-width: 1100px) {
            display: none;
        }
        >div {
            background: #1bb83d;
            border-radius: 7px;
            height: 5px;
        }
    }
    .jackpot-text {
        color: #55657e;
        display: block;
        font-size: 9px;
        font-weight: 600;
        line-height: 10px;
        margin-top: 10px;
        max-width: 115px;
        @media (max-width: 1100px) {
            display: none;
        }
        .jackpot-count {
            color: #fff;
        }
    }
}
</style>